  /* ---- Offer wiring -------------------------------------------------------
     VARIANT  = Olivino Essential variant id (one-time purchase, $44.95).
     CODE_3 / CODE_6 = Shopify discount codes that MUST exist in the store:
       CODE_3 → 15% off Olivino Essential, minimum quantity 3
       CODE_6 → 20% off Olivino Essential, minimum quantity 6
     Each CTA builds a /cart permalink that adds the right quantity and applies
     the matching code, so the pack price is enforced at checkout.
  -------------------------------------------------------------------------- */
  var VARIANT = "40503855775844";
  var CODE_3 = "OLIVINO3PACK";
  var CODE_6 = "OLIVINO6PACK";
  var cartUrl = function (qty, code) {
    var u = "/cart/" + VARIANT + ":" + qty;
    return code ? u + "?discount=" + code : u;
  };
  var TIERS = [
    { n: 1, label: "1 bottle of Olivino Essential",  total: 44.95,  was: 49.95,  save: 5.00,  per: 44.95, cta: "Get the single bottle",  pct: null, url: cartUrl(1) },
    { n: 3, label: "3 bottles of Olivino Essential", total: 114.62, was: 134.85, save: 20.23, per: 38.21, cta: "Get the 3-bottle pack", pct: 15,   url: cartUrl(3, CODE_3) },
    { n: 6, label: "6 bottles of Olivino Essential", total: 215.76, was: 269.70, save: 53.94, per: 35.96, cta: "Get the 6-bottle pack", pct: 20,   url: cartUrl(6, CODE_6) }
  ];
  var selected = 1;
  var fmt = function (v) { return "$" + v.toFixed(2); };

  function renderSelection() {
    var t = TIERS[selected];
    document.querySelectorAll(".tier").forEach(function (el) {
      el.classList.toggle("on", Number(el.dataset.tier) === selected);
    });
    document.getElementById("s-pack").textContent = t.label;
    document.getElementById("s-per").textContent = fmt(t.per) + " / bottle";
    document.getElementById("s-was").textContent = fmt(t.was);
    document.getElementById("s-save").textContent = fmt(t.save) + (t.pct ? " (" + t.pct + "%)" : "");
    document.getElementById("s-total").textContent = fmt(t.total);
    document.getElementById("cta-main").textContent = t.cta;
    /* mobile bar stays a static social-proof nudge ("Most customers choose the 3-pack") */
  }

  document.querySelectorAll(".tier").forEach(function (el) {
    var pick = function () { selected = Number(el.dataset.tier); renderSelection(); };
    el.addEventListener("click", pick);
    el.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); pick(); } });
  });

  document.getElementById("cta-main").addEventListener("click", function () {
    window.location.href = TIERS[selected].url;
  });

  /* grocery calculator: per-day equivalents from the brand's formulation statement */
  var PER_DAY = { grapes: 300, olives: 30, tomatoes: 3, gels: 1 };
  var nf = new Intl.NumberFormat("en-US");
  function setDays(days) {
    document.querySelectorAll(".calc-days button").forEach(function (b) {
      b.classList.toggle("on", Number(b.dataset.days) === days);
    });
    animate("c-grapes", PER_DAY.grapes * days);
    animate("c-olives", PER_DAY.olives * days);
    animate("c-tomatoes", PER_DAY.tomatoes * days);
    animate("c-gels", PER_DAY.gels * days);
  }
  var timers = {};
  function animate(id, target) {
    var el = document.getElementById(id);
    var start = Number(String(el.textContent).replace(/,/g, "")) || 0;
    var t0 = performance.now(), dur = 450;
    if (timers[id]) cancelAnimationFrame(timers[id]);
    (function tick(now) {
      var p = Math.min(1, (now - t0) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = nf.format(Math.round(start + (target - start) * eased));
      if (p < 1) timers[id] = requestAnimationFrame(tick);
    })(t0);
  }
  document.querySelectorAll(".calc-days button").forEach(function (b) {
    b.addEventListener("click", function () { setDays(Number(b.dataset.days)); });
  });

  /* sticky mobile bar: show after hero, hide near offer (its CTA is redundant there) */
  var bar = document.getElementById("mobile-bar");
  var hero = document.querySelector(".hero");
  var offerSec = document.getElementById("offer");
  function onScroll() {
    var pastHero = window.scrollY > hero.offsetTop + hero.offsetHeight;
    var r = offerSec.getBoundingClientRect();
    var overOffer = r.top < window.innerHeight && r.bottom > 0;
    bar.classList.toggle("show", pastHero && !overOffer);
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
  renderSelection();
